export enum MessageType {
  OK = 0,
  YESNO = 1,
  OKCANCEL = 2,
  YESNOCANCEL = 3
}
